import { http } from "./http";

export const auctionsApi = {
  // params sugeridos: { county_id, rule_template_id, auction_type, q, limit, offset, starts_at_from, starts_at_to }
  list: (params) => http.get("/auctions", { params }).then((r) => r.data),

  getById: (id) => http.get(`/auctions/${id}`).then((r) => r.data),

  // payload esperado pelo backend (model):
  // { county_id, auction_type, starts_at, rule_template_id, sampled_by_admin_id, sampled_at?, list_source_url?, notes? }
  create: (payload) => http.post("/auctions", payload).then((r) => r.data),

  update: (id, payload) =>
    http.put(`/auctions/${id}`, payload).then((r) => r.data),
};
